import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models/user';
import { LoginRequest } from '../_models/auth/loginRequest';
import { Usuario } from '../_models/usuario/usuario';
import { JwtResponse } from '../_models/auth/jwtResponse';
import { Router } from '@angular/router';
import { Menu } from 'src/app/_models/usuario/menu';
import { Perfil } from '../_models/usuario/perfil';
import { UpdatePassword } from '../_models/auth/updatePassword';
import { UpdatePasswordResponse } from '../_models/auth/updatePasswordResponse';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public atualUser: Observable<Usuario>;
  private atualUserSubject: BehaviorSubject<Usuario>;
  public atualUserMenu: Observable<Menu[]>;
  private atualUserMenuSubject: BehaviorSubject<Menu[]>;
  public atualUserToken: Observable<string>;
  private atualUserTokenSubject: BehaviorSubject<string>;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.atualUserSubject = new BehaviorSubject<Usuario>(JSON.parse(localStorage.getItem('atualUser')));
    this.atualUser = this.atualUserSubject.asObservable();
    this.atualUserMenuSubject = new BehaviorSubject<Menu[]>(JSON.parse(localStorage.getItem('atualUserMenu')));
    this.atualUserMenu = this.atualUserMenuSubject.asObservable();
    this.atualUserTokenSubject = new BehaviorSubject<string>(JSON.parse(localStorage.getItem('atualUserToken')));
    this.atualUserToken = this.atualUserTokenSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  public get atualUserValue(): Usuario {
    return this.atualUserSubject.value;
  }

  public get atualUserPerfilValue(): Perfil {
    return this.atualUserSubject.value.perfil;
  }

  public get atualUserTokenValue(): string {
    return this.atualUserTokenSubject.value;
  }

  public get atualUserMenuValue(): Menu[] {
    return this.atualUserMenuSubject.value;
  }


  loginAuth(loginRequest: LoginRequest): Observable<JwtResponse> {
      return this.http.post<JwtResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/auth/token`, { loginRequest });
  }

  atualizarSenha(updatePassword: UpdatePassword): Observable<UpdatePasswordResponse> {
    return this.http.post<UpdatePasswordResponse>(`${environment.authorizedUrls.bsCobrancaUrl}/auth/updatePassword`, {
        updatePassword
      });
    }

  storageUser(jwtResponse: JwtResponse) {
    localStorage.setItem('atualUser', JSON.stringify(jwtResponse.usuario));
    this.atualUserSubject.next(jwtResponse.usuario);
    localStorage.setItem('atualUserMenu', JSON.stringify(jwtResponse.menu));
    this.atualUserMenuSubject.next(jwtResponse.menu);
    localStorage.setItem('atualUserToken', JSON.stringify(jwtResponse.token));
    this.atualUserTokenSubject.next(jwtResponse.token);
    if (jwtResponse.usuario.primeiroAcesso) {
      this.router.navigate(['usuario/alterarsenha']);
    } else {
      const perfil = this.atualUserPerfilValue;
      if (perfil.nmePerfil === 'CONSSACADO') {
        this.router.navigate(['sacado/sacado']);
      } else {
          this.router.navigate(['titulo/pesquisatitulo']);
      }
    }
  }

  replaceUser(usuario: Usuario) {
    localStorage.removeItem('atualUser');
    this.atualUserSubject.next(null);
    localStorage.setItem('atualUser', JSON.stringify(usuario));
    this.atualUserSubject.next(usuario);
  }

  login(loginRequest: LoginRequest) {
    return this.http.post<any>(`${environment.authorizedUrls.authUrl}/auth/token`, { loginRequest })
    .pipe(map(user => {
      // login successful if there's a jwt token in the response
      if (user && user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
      }
      return user;
    }));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    localStorage.removeItem('atualUser');
    localStorage.removeItem('atualUserMenu');
    localStorage.removeItem('atualUserToken');
    this.atualUserSubject.next(null);
    this.currentUserSubject.next(null);
    this.atualUserMenuSubject.next(null);
    this.atualUserTokenSubject.next(null);
    this.router.navigate(['login']);
  }
}
